import * as styles from './StatusDot.css'

export type StatusDotProps = {
  status: 'SUCCESS' | 'WARNING' | 'ERROR'
}

export const StatusDot = ({ status }: StatusDotProps) => (
  <div className={styles.statusDot({ status })} />
)
